module.exports = __webpack_public_path__ + "static/media/gear-upgrade.3153ceb5.png";